// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"8413":"7ccb458ec6787ce3","8986":"857fa760aa641981","9651":"b2d35074ca2f0143"}[chunkId] + ".css";
};